import { createAppAsyncThunk } from '@/domain/store.thunk';
import { downloadFileFromCode } from '@/domain/utils/download-a-file-from-code';

export const downloadVenueImportCsvTemplate = createAppAsyncThunk(
  'projectVenueDates/downloadVenueImportCsvTemplate',
  async () => {
    const url = '/fairly_score_import_venue_dates-template.csv';
    const filename = 'fairly_score_import_venue_dates-template.csv';
    downloadFileFromCode(url, filename);
  },
);
